var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[(_vm.showBreadcrumb)?_c('router-view'):[(_vm.$route.meta.layout === 'layout-base')?_c('layout-base'):_vm._e(),(_vm.$route.meta.layout === 'layout-admin')?_c('layout-admin'):_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }